import React from "react"

import { getOrdersTaxItems, thousandSeparator } from "utils"
import classes from "./OrderDetailsTaxes.module.scss"

const OrderDetailsTaxes = props => {
  const { order } = props

  const taxes = getOrdersTaxItems(order)

  return (
    taxes.map(tax =>
      tax.amount !== 0
        ?
        <div
          key={tax.title}
          className={classes["totalItem"]}
        >
          <div>
            {tax.title}{" "}
            {tax.isPercentageModel ? `(${tax.percentage}%)` : ""}
          </div>
          <div className={classes["number"]}>
            {thousandSeparator(tax.amount)}
          </div>
        </div>
        :
        null
    )
  )
}

export default OrderDetailsTaxes